//node modules
import { useState } from "react";
import { Link } from "react-router-dom";

//style files
import logo from "../../assets/images/logo.png";

const Navbar = () => {
  const [toggle, setToggle] = useState(false);

  const OpenMenu = () => {
    setToggle(true);
    document.body.style.overflowY = "hidden";
  };
  const CloseMenu = () => {
    setToggle(false);
    document.body.style.overflowY = "auto";
  };

  return (
    <>
      <div className="flex w-full justify-center bg-custom-red py-6 fixed z-10 shadow-md border- ">
        <div className="w-4/5 max-w-screen-xl flex flex-row justify-between items-center">
          <div>
            <a href="https://www.raysigorta.com.tr/">
              <img src={logo} alt="ray-sigorta-logo" width={130} />
            </a>
          </div>
          <div className="hidden lg:block">
            <ul className="flex flex-row text-white font-medium">
              <li className="mx-2 text-sm hover:text-black">
                <a href="#rail-of-future">Geleceğin Ray'ında Nedir?</a>
              </li>
              <li className="mx-2 text-sm hover:text-black">
                <a href="#who-can-join">Kimler Katılabilir?</a>
              </li>
              <li className="mx-2 text-sm hover:text-black">
                <a href="#timeline-section">Süreç</a>
              </li>
              <li className="mx-2 text-sm hover:text-black">
                <a href="#what-awaits-you">Seni neler bekliyor?</a>
              </li>
              <li className="mx-2 text-sm hover:text-black">
                <a href="#faq-section">SSS</a>
              </li>
              <li className="mx-2 text-sm hover:text-black">
                <a href="#about-Ray-insurance">Ray Sigorta Hakkında</a>
              </li>
            </ul>
          </div>
          <div className="hidden lg:block">
            <a
              className="border border-white px-3 py-2 text-white font-extrabold hover:bg-white hover:text-black"
              href="#application-form"
            >
              Hemen Başvur
            </a>
          </div>
          <div
            onClick={() => {
              OpenMenu();
            }}
            className="lg:hidden block"
          >
            <button className="flex flex-col space-y-1 p-2 rounded-md">
              <div className="w-6 h-1 bg-white rounded-sm"></div>
              <div className="w-6 h-1 bg-white rounded-sm"></div>
              <div className="w-6 h-1 bg-white rounded-sm"></div>
            </button>
          </div>
        </div>
      </div>
      <div
        className={
          toggle
            ? "block w-screen1 h-screen1 fixed bg-gray-900 top-0 left-0 bottom-0 right-0 z-10 py-12 overflow-y-auto select-none"
            : "hidden w-screen1 h-screen1 fixed bg-gray-900 top-0 left-0 bottom-0 right-0 z-10 py-12  overflow-y-auto select-none"
        }
      >
        <div
          onClick={CloseMenu}
          className="w-7 h-7 border-2 border-white bg-gray-900 fixed top-5 right-5 flex justify-center items-center text-white font-bold hover:border-gray-700 hover:text-gray-700 transition-all duration-100"
        >
          x
        </div>
        <ul className="flex flex-col space-y-5 divide-y divide-gray-700 pl-5">
          <li className="mx-2 pt-5">
            <a
              className="block w-100 h-100 text-gray-700 text-3xl font-bold uppercase hover:text-red-600 focus:text-red-600"
              onClick={CloseMenu}
              href="#rail-of-future"
            >
              Geleceğin Ray'ında Nedir?
            </a>
          </li>
          <li className="mx-2 pt-5">
            <a
              className="block w-100 h-100 text-gray-700 text-3xl font-bold uppercase hover:text-red-600 focus:text-red-600"
              onClick={CloseMenu}
              href="#who-can-join"
            >
              Kimler Katılabilir?
            </a>
          </li>
          <li className="mx-2 pt-5">
            <a
              className="block w-100 h-100 text-gray-700 text-3xl font-bold uppercase hover:text-red-600 focus:text-red-600"
              onClick={CloseMenu}
              href="#timeline-section"
            >
              Süreç
            </a>
          </li>
          <li className="mx-2 pt-5">
            <a
              className="block w-100 h-100 text-gray-700 text-3xl font-bold uppercase hover:text-red-600 focus:text-red-600"
              onClick={CloseMenu}
              href="#what-awaits-you"
            >
              Seni neler bekliyor?
            </a>
          </li>
          <li className="mx-2 pt-5">
            <a
              className="block w-100 h-100 text-gray-700 text-3xl font-bold uppercase hover:text-red-600 focus:text-red-600"
              onClick={CloseMenu}
              href="#faq-section"
            >
              SSS
            </a>
          </li>
          <li className="mx-2 pt-5">
            <a
              className="block w-100 h-100 text-gray-700 text-3xl font-bold uppercase hover:text-red-600 focus:text-red-600"
              onClick={CloseMenu}
              href="#about-Ray-insurance"
            >
              Ray Sigorta Hakkında
            </a>
          </li>
          <li className="mx-2 pt-5">
            <a
              className="block w-100 h-100 text-gray-700 text-3xl font-bold uppercase hover:text-red-600 focus:text-red-600"
              onClick={CloseMenu}
              href="#application-form"
            >
              Hemen Başvur
            </a>
          </li>
        </ul>
      </div>
    </>
  );
};
export default Navbar;
